import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { McRAIInputModule } from '../input/input.module';
import { SelectComponent } from './components/select/select.component';
import { McRAIPaginatorModule } from '../paginator/paginator.module';
import { McRAIPanelModule } from '../panel/panel.module';
import { OptionComponent } from './components/option/option.component';

@NgModule({
  imports: [
    CommonModule,
    McRAIInputModule,
    OverlayModule,
    McRAIPanelModule,
    McRAIPaginatorModule
  ],
  declarations: [
    SelectComponent,
    OptionComponent
  ],
  exports: [
    SelectComponent,
    OptionComponent
  ]
})
export class McRAISelectModule { }
